module.exports = __webpack_public_path__ + "static/media/customer.d4b5d557.webp";